import React from 'react';

import styles from './step.module.css';
import Message from '../../Message';

interface StepProps {
    step: number;
    title: string;
    description: string;
}

const Step = ({ step, title, description }: StepProps) => {
    return (
        <div className={styles.stepWrapper}>
            <div className={styles.stepNumber}>
                <span>{step}</span>
            </div>
            <div className={styles.stepContent}>
                <h2 className={styles.textHeadline}>
                    <Message code={title} />
                </h2>
                <Message className={styles.textDescription} code={description} />
            </div>
        </div>
    );
};

export default Step;
